import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
import { createContext, use, useMemo } from "react";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//#region src/badge/Badge.tsx
const BadgeContext = createContext({
	size: "md",
	color: "neutral",
	variant: "pill"
});
const Badge = ({ size = "md", color = "neutral", variant = "pill", className, children, onClose, ...rest }) => {
	const ctx = useMemo(() => ({
		size,
		color,
		variant
	}), [
		size,
		color,
		variant
	]);
	return /* @__PURE__ */ jsx(BadgeContext, {
		value: ctx,
		children: /* @__PURE__ */ jsxs("div", {
			className: twMerge("flex w-fit items-center gap-1 text-sm font-medium", color === "neutral" && "bg-gray-50 text-gray-700", color === "primary" && "bg-blue-50 text-blue-700", color === "brand" && "bg-brand-50 text-brand-700", color === "error" && "bg-red-50 text-red-700", color === "warning" && "bg-orange-50 text-orange-700", color === "success" && "bg-green-50 text-green-700", color === "dark" && "bg-gray-900 text-white", variant === "outline" && "rounded-full border bg-white text-gray-900", variant === "outline" && color === "neutral" && "[&>svg]:text-gray-500", variant === "outline" && color === "primary" && "[&>svg]:text-blue-500", variant === "outline" && color === "brand" && "[&>svg]:text-brand-500", variant === "outline" && color === "error" && "[&>svg]:text-red-500", variant === "outline" && color === "warning" && "[&>svg]:text-orange-500", variant === "outline" && color === "success" && "[&>svg]:text-green-500", variant === "outline" && color === "dark" && "[&>svg]:text-gray-500", variant === "pill" && "rounded-full", variant === "rounded" && "rounded-md", size === "xs" && "px-1.5 py-0.25 text-[0.625rem]", size === "sm" && "px-2 py-0.5 text-xs", size === "md" && "px-2.5 py-0.5", size === "lg" && "px-3 py-1", className),
			...rest,
			children: [children, onClose && /* @__PURE__ */ jsx(BadgeClose, { onClick: onClose })]
		})
	});
};
const BadgeClose = ({ className, type = "button", ...rest }) => {
	const { color, variant, size } = use(BadgeContext);
	return /* @__PURE__ */ jsx("button", {
		"aria-label": "Close",
		type,
		className: twMerge("-mr-1.5 flex size-4 items-center justify-center leading-none outline-hidden", size === "xs" && "size-3", size === "sm" && "size-3.5", color === "neutral" && "text-gray-400 hover:bg-gray-200 focus-visible:outline-gray-400", color === "primary" && "text-blue-400 hover:bg-blue-100 focus-visible:outline-blue-400", color === "brand" && "text-brand-400 hover:bg-brand-100 focus-visible:outline-brand-400", color === "error" && "text-red-400 hover:bg-red-100 focus-visible:outline-red-400", color === "warning" && "text-orange-400 hover:bg-orange-100 focus-visible:outline-orange-400", color === "success" && "text-green-400 hover:bg-green-100 focus-visible:outline-green-400", color === "dark" && "text-gray-300 hover:bg-gray-700 focus-visible:outline-gray-300", variant === "pill" && "rounded-full", variant === "rounded" && "rounded-xs", className),
		...rest,
		children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
			icon: faXmark,
			className: twMerge("size-3 text-inherit", size === "xs" && "size-2", size === "sm" && "size-2.5")
		})
	});
};
//#endregion
export { Badge, BadgeContext };
